import { receptionNavigationItems, receptionRoutes } from "./router";
export class ReceptionModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[ReceptionModule] Registered");
        return { id: "reception", name: "Reception Module", version: "1.0.0" };
    }
    getRoutes() {
        return receptionRoutes;
    }
    getNavigationItems() {
        return receptionNavigationItems;
    }
    getComponent(_slotName) {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[ReceptionModule] Unregistered");
        this.contracts = null;
    }
}
export default new ReceptionModule();
